import {of} from 'rxjs';
import {catchError, filter, map, mergeMap} from 'rxjs/operators';
import {isActionOf, RootEpic} from 'typesafe-actions';
import {IRxAxiosError} from '../../../shared';
import {eSingleLoadPlatesAsync, eSingleRequestVotingAsync} from './actions';

export const eSingleLoadPlatesAsyncEpic: RootEpic = (
  action$,
  state$,
  {electionApi}
) =>
  action$.pipe(
    filter(isActionOf(eSingleLoadPlatesAsync.request)),
    mergeMap(action => {
      return electionApi.loadManyPlateDetailByUuid(action.payload).pipe(
        map(data => eSingleLoadPlatesAsync.success(data)),
        catchError((error: IRxAxiosError) =>
          of(eSingleLoadPlatesAsync.failure(error.message))
        )
      );
    })
  );

export const eSingleVoteAsyncEpic: RootEpic = (
  action$,
  state$,
  {electionApi}
) =>
  action$.pipe(
    filter(isActionOf(eSingleRequestVotingAsync.request)),
    mergeMap(action => {
      return electionApi.singleVote(action.payload).pipe(
        map(data => eSingleRequestVotingAsync.success(data)),
        catchError((error: IRxAxiosError) =>
          of(eSingleRequestVotingAsync.failure(error.message))
        )
      );
    })
  );



// WEBPACK FOOTER //
// ./src/features/election-single/store/epics.ts